const initialState = {
  posts: [],
  current: null
};

export default initialState;
